import { SR_API_ACTION_PARTNER_GET_MARKET_CONFIGURATION } from 'api/actionTypes';

export default async function getMarketConfiguration(
  { state, apiClient },
  { partnerId, marketId },
) {
  const statePath = ['partners', 'marketConfigurationByIds', `${partnerId}-${marketId}`];
  if (state.get(statePath)) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_MARKET_CONFIGURATION,
    state: state,
    payload: {
      partnerId,
      marketId,
    },
    onSuccess(partnerOverviewStats) {
      state.set(statePath, partnerOverviewStats);
    },
  });
}
